import type { ContentCourseWithLessons, ContentPage } from '@doneverse/shared'
import { api } from '../api/index.js'

export interface DoersUniversityCatalog {
  page: ContentPage
  courses: ContentCourseWithLessons[]
}

export const doersUniversityService = {
  // Returns null when the page hasn't been published yet (API 404s on a missing
  // content_pages row) so the page renders its empty state instead of throwing.
  catalog: async (): Promise<DoersUniversityCatalog | null> => {
    return api
      .get('/doers-university')
      .notFound(() => null)
      .json<DoersUniversityCatalog>()
  },
}
